import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { message } from 'antd';
import Cookies from 'js-cookie';
import { checkIsYaotaiInternalUser, useLoginInfo } from '@yaotai/common-utils';
import { useUserInfo } from '../hooks';
import { encodeNextUrl } from '../utils';

// 基础 Layout 下所有需要登录校验的页面，且不能是内部帐号
const AUTH_ROUTE_PREFIX_LIST = ['/user', '/user/info'];

export function useLoginAuthCheck() {
  const location = useLocation();
  const navigate = useNavigate();
  const { login_type } = useUserInfo();
  const { isLogin, handleLogOut } = useLoginInfo();

  const isMatchAuthCheck = AUTH_ROUTE_PREFIX_LIST.some(item => location.pathname === item);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const RBAC_TOKEN = urlParams.get('RBAC_TOKEN');
    if (isMatchAuthCheck) {
      //NOTE: 防止 isLogin 的初始状态的误判
      //NOTE: 在跨域写入 TOKEN 的时候需要加额外的判断逻辑
      if (!Cookies.get('RBAC_TOKEN') && !RBAC_TOKEN) {
        navigate(`/login?next=${encodeNextUrl(window.location.href)}`);
        return;
      }
      if (isLogin && checkIsYaotaiInternalUser(login_type)) {
        handleLogOut();
        message.warning('系统支持者帐号仅允许用于活动配置');
        navigate(`/login?next=${encodeNextUrl(window.location.href)}`);
      }
    } else {
      //NOTE: 内部帐号在其他页面的登录状态清空
      if (isLogin && checkIsYaotaiInternalUser(login_type)) {
      }
    }
  }, [isLogin, isMatchAuthCheck, login_type]);
}
